import React from "react";
import { defineMessages } from "react-intl";
import { useSelector } from "react-redux";
import { getErrorByCode } from "../../../intl/shared-resources/serverResponse.js";
import { makeStyles } from "tss-react/mui";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "@mui/material";
import "../../../components/alerts/Message.style.js";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { ErrorAlert } from "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { gridMaxSize } from "../../../components/data-grid/mui/types.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "moment-timezone";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import { Icon, IconColor } from "../../../components/icons/Icon.js";
import { CustomIcon } from "../../../components/icons/types.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { useBulkOperationExecutionError } from "../hooks.js";
import { itemsSelector } from "../selectors.js";
import { bulkItemFailedStatues, BulkItemStatus } from "../types.js";
import { BulkExecutionStepTotalProgress } from "./BulkExecutionStepTotalProgress.js";
import { BulkActionSummaryDetailsInfo, BulkActionSummaryDetailsInfoExpanded } from "./BulkSummaryStepActionItem.js";
import { BulkSummaryStepActionLabel } from "./BulkSummaryStepActionLabel.js";
import { BulkTotalCountChip } from "./BulkTotalCountChip.js";
const localized = defineMessages({
  bulkStepExecutionSummarySkippedLabel: {
    id: "bulkStepExecutionSummarySkippedLabel",
    defaultMessage: "Skipped"
  },
  bulkStepExecutionSummaryPartiallyAppliedLabel: {
    id: "bulkStepExecutionSummaryPartiallyApplied",
    defaultMessage: "Applied partially"
  },
  bulkStepExecutionSummaryAppliedLabel: {
    id: "bulkStepExecutionSummaryAppliedLabel",
    defaultMessage: "Applied"
  }
});
const useClasses = makeStyles()(() => ({
  bulkStepExecutionSummaryResultIcon: {
    fontSize: "1.5em"
  }
}));
function useExecutionData(actionItems, isOperationFailed) {
  const selectedItems = useSelector(itemsSelector);
  function getSelectedItemById(id, index, value) {
    const item = selectedItems?.some((item2) => item2.serverId) ? selectedItems?.find((r) => r.serverId === id) : value;
    return { ...item, rowIndex: item?.rowIndex ?? index };
  }
  function getPartiallySuccessfulRows() {
    const successfulItems = isOperationFailed ? [] : actionItems?.filter((i) => i.status === BulkItemStatus.PartiallySuccessful);
    return successfulItems?.map((i, index) => ({
      ...getSelectedItemById(i?.itemId, index, i?.value),
      ...typeof i?.value === "object" ? i?.value : {},
      error: void 0,
      rawErrorMessage: void 0
    })) ?? [];
  }
  function getSuccessfulRows() {
    const successfulItems = isOperationFailed ? [] : actionItems?.filter((i) => i.status === BulkItemStatus.Successful);
    return successfulItems?.map((i, index) => ({
      ...getSelectedItemById(i?.itemId, index, i?.value),
      ...typeof i?.value === "object" ? i?.value : {},
      error: void 0,
      rawErrorMessage: void 0
    })) ?? [];
  }
  function getFailedRows() {
    const failedItems = isOperationFailed ? actionItems : actionItems?.filter((i) => bulkItemFailedStatues.includes(i.status));
    return failedItems?.map((i, index) => ({
      ...getSelectedItemById(i?.itemId, index, i?.value),
      ...typeof i?.value === "object" ? i?.value : {},
      error: getErrorByCode(i.errorCode),
      rawErrorMessage: i.message
    })) ?? [];
  }
  return {
    successfulItems: getSuccessfulRows(),
    partiallySuccessfulItems: getPartiallySuccessfulRows(),
    failedItems: getFailedRows()
  };
}
function BulkDetailsInfoExpanded({ items, children, size, status }) {
  const { classes } = useClasses();
  function getLabel() {
    const labelMap = {
      failed: localized.bulkStepExecutionSummarySkippedLabel,
      partialSuccess: localized.bulkStepExecutionSummaryPartiallyAppliedLabel,
      success: localized.bulkStepExecutionSummaryAppliedLabel
    };
    return labelMap[status];
  }
  const isSuccessful = status === "success";
  return /* @__PURE__ */ React.createElement(
    BulkActionSummaryDetailsInfoExpanded,
    {
      actionLabel: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        Icon,
        {
          icon: isSuccessful ? CustomIcon.ConfirmCircle : CustomIcon.ErrorCircleOutline,
          color: isSuccessful ? IconColor.Success : IconColor.Warning,
          className: classes.bulkStepExecutionSummaryResultIcon
        }
      ), /* @__PURE__ */ React.createElement(LocalizedText, { label: getLabel() })),
      actionTotal: /* @__PURE__ */ React.createElement(BulkTotalCountChip, { totalItems: items?.length, chipType: isSuccessful ? "successDark" : "warningDark" }),
      size
    },
    children
  );
}
function withBulkStepSummaryContentDataGridBase(WrappedDataGrid, { columns, expandable, errorMapping }, getGridProps) {
  return ({
    actionKey,
    affectedEntityName,
    actionItems,
    isProcessingFinished,
    isOperationFailed,
    withFlexibleGrid,
    label,
    getLabelParams
  }) => {
    const { successfulItems, partiallySuccessfulItems, failedItems } = useExecutionData(actionItems, isOperationFailed);
    const isSuccessfulItemsVisible = successfulItems?.length > 0;
    const isPartiallySuccessfulItemsVisible = partiallySuccessfulItems?.length > 0;
    const isFailedItemsVisible = failedItems?.length > 0;
    const error = useBulkOperationExecutionError({ isOperationFailed, actionKey, errorMapping });
    function renderGridRows(rows) {
      return /* @__PURE__ */ React.createElement(
        WrappedDataGrid,
        {
          ...getGridProps({
            rows,
            gridColumns: columns,
            withFlexibleGrid
          })
        }
      );
    }
    return actionItems?.length > 0 ? /* @__PURE__ */ React.createElement(
      BulkActionSummaryDetailsInfo,
      {
        key: `summaryDetails-${actionKey}`,
        expandable,
        actionKey,
        actionLabel: label ? /* @__PURE__ */ React.createElement(LocalizedText, { label, labelParams: getLabelParams ? getLabelParams(actionItems?.[0]?.value) : {} }) : /* @__PURE__ */ React.createElement(BulkSummaryStepActionLabel, { actionKey, labelValue: actionItems?.[0]?.labelValue }),
        actionTotal: /* @__PURE__ */ React.createElement(
          BulkExecutionStepTotalProgress,
          {
            totalItems: actionItems?.length,
            processedItems: isOperationFailed ? actionItems?.length : [...successfulItems, ...partiallySuccessfulItems, ...failedItems]?.length,
            failedItems: isOperationFailed ? actionItems?.length : failedItems.length,
            affectedEntityName
          }
        )
      },
      error ? /* @__PURE__ */ React.createElement(ErrorAlert, { title: error }) : null,
      isProcessingFinished && !isOperationFailed && isFailedItemsVisible ? /* @__PURE__ */ React.createElement(
        BulkDetailsInfoExpanded,
        {
          status: "failed",
          items: failedItems,
          size: isSuccessfulItemsVisible || isPartiallySuccessfulItemsVisible ? "small" : "normal"
        },
        renderGridRows(failedItems)
      ) : /* @__PURE__ */ React.createElement(React.Fragment, null),
      isProcessingFinished && !isOperationFailed && isPartiallySuccessfulItemsVisible ? /* @__PURE__ */ React.createElement(
        BulkDetailsInfoExpanded,
        {
          status: "partialSuccess",
          items: partiallySuccessfulItems,
          size: isSuccessfulItemsVisible || isFailedItemsVisible ? "small" : "normal"
        },
        renderGridRows(partiallySuccessfulItems)
      ) : /* @__PURE__ */ React.createElement(React.Fragment, null),
      isProcessingFinished && !isOperationFailed && isSuccessfulItemsVisible ? /* @__PURE__ */ React.createElement(
        BulkDetailsInfoExpanded,
        {
          status: "success",
          items: successfulItems,
          size: isPartiallySuccessfulItemsVisible || isFailedItemsVisible ? "small" : "normal"
        },
        renderGridRows(successfulItems)
      ) : /* @__PURE__ */ React.createElement(React.Fragment, null)
    ) : null;
  };
}
const withBulkStepSummaryContentDataGrid = (WrappedDataGrid, { columns, expandable, errorMapping }) => withBulkStepSummaryContentDataGridBase(
  WrappedDataGrid,
  { columns, expandable, errorMapping },
  ({ rows, gridColumns, withFlexibleGrid: isFlexible }) => ({
    rows,
    rawModels: rows?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
    columns: gridColumns,
    rowsPerPageOptions: [gridMaxSize],
    hidePagination: rows.length < gridMaxSize,
    autoHeight: true,
    isFlexible
  })
);
const withBulkStepSummaryContentDataGridGlide = (WrappedDataGrid, { columns, expandable, errorMapping }) => withBulkStepSummaryContentDataGridBase(
  WrappedDataGrid,
  { columns, expandable, errorMapping },
  ({ rows, gridColumns, withFlexibleGrid: isFlexible }) => ({
    rows,
    rawModels: rows?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
    columns: gridColumns,
    hidePagination: true,
    isFlexible,
    gridFullPage: false,
    maxVisibleRows: Math.min(10, rows?.length ?? 0)
  })
);
export {
  localized,
  withBulkStepSummaryContentDataGrid,
  withBulkStepSummaryContentDataGridGlide
};
//# sourceMappingURL=BulkExecutionStepDetailsContent.js.map
